import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import LandingPage from "./home/landingPage";
import ContactPage from "./contactus/contactus";
import CompleteSignup from "./completeSignup";
import ProtectedRoute from "./components/protectedRoute"; 
import BlogHome from "./blog/blogHome";
import Article1 from "./blog/article1";
import Article2 from "./blog/article2";
import Article3 from "./blog/article3";
import ComingSoon from "./home/comingSoon";
import LawyerVideo from "./lawyer/video/lawyerVideo";
import ForLawyers from "./forlawyers/forLawyers";
import CompleteSignupInvited from "./completeSignupInvited";
import ClientRoutes from "./client/clientRoutes";
import ClientVideo from "./client/video/clientVideo";
import WaitList from "./waitlist/waitList";
import LawyerSignup from "./onboarding/lawyerSignup/lawyerSignup";
import SetPassword from "./onboarding/lawyerSignup/setPassword";
import ConfirmEmail from "./onboarding/lawyerSignup/confirmEmail";
import Login from "./onboarding/lawyerSignup/login";
import SetGoals from "./onboarding/lawyerSignup/setGoals";
import Recommendations from "./onboarding/lawyerSignup/recommendations";
import LawyerRoutes from "./lawyer/lawyerRoutes";
import Email from "./lawyer/login/email";
import Password from "./lawyer/login/password";
import SearchResultsClient from "./client/searchResults/searchResults";
import LawyerDetail from "./client/lawyerSelection/lawyerDetail";
import HomePage from "./home/new/homePage";
import ClientSignup from "./onboarding/clientSignup/clientSignup";
import ClientSignupWithAppointment from "./onboarding/clientSignup/clientSignupWithAppointment";
import ResetPasswordEmail from "./lawyer/login/resetPasswordEmail";
import PasswordResetRequest from "./lawyer/login/passwordResetRequest";
import UpdatePassword from "./lawyer/login/updatePassword";
import RedirectPage from "./lawyer/login/redirectPage";
import InvitedSignup from "./onboarding/lawyerSignup/invitedSignup";
import InvitedSetPassword from "./onboarding/lawyerSignup/invitedSetPassword";
import InvitedRedirect from "./onboarding/lawyerSignup/invitedRedirect";
import RedirectClient from "./home/new/components/forgotPassword/redirectClient";
import ChangePassword from "./home/new/components/forgotPassword/changePassword";
import PasswordResetClient from "./home/new/components/forgotPassword/passwordResetClient";
import VerifyEmail from "./home/new/components/forgotPassword/verifyEmail";
import ConfirmEmailClient from "./onboarding/clientSignup/confirmEmailClient";
import ClientDetails from "./onboarding/clientSignup/clientDetails";
import FirmDetail from "./client/lawyerSelection/firmDetail";
import IntakePage from "./client/intake/intakePage";

import { ScrollToTop } from "./utils";
import { useLayoutEffect } from "react";
import NotFound from "./components/NotFound";
// import { clearPersistedData } from "./utils/persistCleanup";

const ClientDashboard = () => {
  return (
    <div className="app-container">
      <ClientRoutes /> {/* Separate router for the dashboard */}
    </div>
  );
};

const AttorneyConsole = () => {
  return (
    <div className="app-container">
      <LawyerRoutes /> {/* Separate router for the dashboard */}
    </div>
  );
};

const Wrapper = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  return children;
};

function App() {
  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     clearPersistedData();
  //   };
  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  return (
    <Router>
      <Wrapper>
        <Routes>
          {/* Public Routes */}
          <Route path="/old-home" element={<LandingPage />} />

          <Route path="/" element={<HomePage />} />
          <Route path="/search-results" element={<SearchResultsClient />} />
          <Route path="/lawyer-detail/:id" element={<LawyerDetail />} />
          <Route path="/firm-detail/:id" element={<FirmDetail />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/createuser/auth" element={<ClientSignup />} />
          <Route
            path="/createuser/confirm-email"
            element={<ConfirmEmailClient />}
          />
          <Route path="/createuser/details" element={<ClientDetails />} />
          <Route
            path="/createuser/auth-appointment"
            element={<ClientSignupWithAppointment />}
          />

          <Route path="/complete-signup" element={<CompleteSignup />} />
          <Route
            path="/complete-signup-invited"
            element={<CompleteSignupInvited />}
          />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/blog" element={<BlogHome />} />
          <Route path="/article/1" element={<Article1 />} />
          <Route path="/article/2" element={<Article2 />} />
          <Route path="/article/3" element={<Article3 />} />
          <Route path="/waitlist" element={<WaitList />} />
          <Route path="/grow/sign-up" element={<LawyerSignup />} />
          <Route path="/grow/invited" element={<InvitedSignup />} />
          <Route path="/grow/attorney" element={<ForLawyers />} />
          <Route path="/intake/:token" element={<IntakePage />} />
          <Route
            path="/grow/invited/set-password"
            element={<InvitedSetPassword />}
          />
          <Route path="/grow/invited/redirect" element={<InvitedRedirect />} />
          <Route path="/grow/set-password" element={<SetPassword />} />
          <Route path="/grow/confirm-email" element={<ConfirmEmail />} />
          <Route path="/grow/login" element={<Login />} />
          <Route path="/grow/email" element={<Email />} />
          <Route path="/grow/password" element={<Password />} />
          <Route path="/grow/reset-password" element={<ResetPasswordEmail />} />
          <Route
            path="/grow/reset-request"
            element={<PasswordResetRequest />}
          />
          <Route path="/grow/update-password" element={<UpdatePassword />} />
          <Route path="/grow/redirect" element={<RedirectPage />} />

          <Route path="/auth/reset-password" element={<VerifyEmail />} />
          <Route path="/auth/reset-request" element={<PasswordResetClient />} />
          <Route path="/auth/update-password" element={<ChangePassword />} />
          <Route path="/auth/redirect" element={<RedirectClient />} />

          <Route
            path="/grow/set-goals"
            element={
              <ProtectedRoute>
                <SetGoals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/grow/recommendations"
            element={
              <ProtectedRoute>
                <Recommendations />
              </ProtectedRoute>
            }
          />

          <Route path="/lawyer-video" element={<LawyerVideo />} />
          {/* Protected Dashboard Route */}

          <Route
            path="/attorney/*"
            element={
              <ProtectedRoute>
                <AttorneyConsole />
              </ProtectedRoute>
            }
          />

          <Route path="/client-video" element={<ClientVideo />} />

          <Route
            path="/client/*"
            element={
              <ProtectedRoute>
                <ClientDashboard />
              </ProtectedRoute>
            }
          />

          {/* Catch-all route for 404s - must be the last route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Wrapper>
    </Router>
  );
}

export default App;
